import React, { useEffect } from "react"
import { HugoStateApi, useScrollable, useTemplateEngine, useButton } from "../hugo"
import cvHugo from './cv.hugo'
import { useNavigate } from "react-router-dom"
import { Cell, Icon, Paper, Row, Wall, externalUrlIcon } from "../ui"
import cvImage from './assets/cv.jpg'

type Props = {
    hugoApi: HugoStateApi
}

const CV: React.FC<Props> = ({ hugoApi }) => {
    const render = useTemplateEngine();
    const scrollable = useScrollable()
    const navigate = useNavigate()
    const [backButton] = useButton({
        label: '◄ Back',
        onClick: () => {
            navigate('/', { state: 'hugo' })
        },
        position: { x: 1, y: 0 },
        visible: true,
    })
    const [downloadButton] = useButton({
        label: '↓ Download CV',
        onClick: () => {
            window.open(process.env.PUBLIC_URL + '/docs/cv_alexander_muehrenberg.pdf', '_blank');
        },
        position: { x: 14, y: 0 },
        visible: true,
    })

    useEffect(() => {
        setTimeout(() => { hugoApi.output(render(cvHugo), { append: false, plugins: [scrollable, backButton, downloadButton] }) }, 100)
    }, [])

    return (
        <Wall>
            <Paper $rotate={-4}>
                <Row $height={1} $skewStrength={3} $image={cvImage} $grayscale={0.9}>
                    <Cell $width={2} ></Cell>
                </Row>
                <Row $height={1} $skewStrength={3} $image={cvImage} $grayscale={0.9}>
                    <Cell $width={2} ></Cell>
                </Row>
                <Row $height={1} $skewStrength={1} $image={cvImage} $grayscale={0.9}>
                    <Cell $width={2} ></Cell>
                </Row>
            </Paper>

            <Paper $rotate={3}>
                <Row $height={1.1} $skewStrength={0.5} $hueRotate={-50} $contrast={100} $saturate={170} $brightness={95}>
                    <Cell $width={1.1}>
                        <h3>alex_cv.pdf</h3>
                        <p>
                            <a
                                href={process.env.PUBLIC_URL + "/docs/cv_alexander_muehrenberg.pdf"}
                                target="_blank"
                                style={{
                                    transform: 'rotate(-15deg)',
                                    marginLeft: '-0.5em',
                                    marginTop: '0.5em',
                                    fontSize: '1.1em',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold',
                                }}
                            >
                               Download Link <Icon src={externalUrlIcon} />
                            </a>
                        </p>
                    </Cell>
                </Row>
            </Paper>
        </Wall>
    )
}

export default CV